import React, { useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import Seleccionartipusdematerials from "./Seleccionartipusdematerials";
import Detallstipusdematerials from "./Detallstipusdematerials";
import "../dashboard_v2.css";
import AjudaCataleg from "./AjudaCataleg";
import { BotoAjuda } from "./AjudaModal";

function idTipus(t) {
  return t ? Number(t.idTipusDeMaterials ?? t.idTipusDeMaterial) : null;
}

function TipusDeMaterials() {
  const [activeTab, setActiveTab] = useState("seleccionar");
  const [selectedTipus, setSelectedTipus] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [categoriaFilter, setCategoriaFilter] = useState("");
  const [mostrarActius, setMostrarActius] = useState(true);
  const [reloadToken, setReloadToken] = useState(0);
  const [tipusList, setTipusList] = useState([]);
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const { rolUsuari } = useUserContext();

  const tornarLlista = (refresca = false) => {
    setActiveTab("seleccionar");
    if (refresca) setReloadToken((n) => n + 1);
  };

  const handleTipusSelect = (tipus) => {
    setSelectedTipus((prev) => (idTipus(prev) === idTipus(tipus) ? null : tipus));
  };

  const obrirFitxa = (tipus, mode) => {
    setSelectedTipus(tipus);
    setActiveTab(mode);
  };

  const esLlista = activeTab === "seleccionar";

  return (
    <div className="dv2 dv2-page dv2-page--fill">
      {mostraAjuda && <AjudaCataleg pestanya="tipusmaterials" onTancar={() => setMostraAjuda(false)} />}
      {esLlista ? (
        <>
          <div className="dv2-pageHeader">
            <div className="dv2-pageHeader-main">
              <div className="dv2-pageHeader-icon" aria-hidden="true">
                🧩
              </div>
              <div>
                <h1 className="dv2-pageHeader-title">Tipus de materials</h1>
                <p className="dv2-pageHeader-subtitle">
                  Cada tipus pertany a una categoria i agrupa els materials.
                </p>
              </div>
            </div>
            <div className="dv2-pageHeader-actions">
              <BotoAjuda title="Com funcionen els Tipus de materials" onClick={() => setMostraAjuda(true)} />
              {tincPermis(rolUsuari, "CREAR") && (
                <button
                  type="button"
                  className="dv2-btn dv2-btn--primary"
                  onClick={() => {
                    setSelectedTipus(null);
                    setActiveTab("nou");
                  }}
                >
                  Nou tipus
                </button>
              )}
            </div>
          </div>

          <Seleccionartipusdematerials
            onTipusSelect={handleTipusSelect}
            onConsultar={(tipus) => obrirFitxa(tipus, "consultar")}
            onModificar={(tipus) => obrirFitxa(tipus, "modificar")}
            onEsborrar={(tipus) => obrirFitxa(tipus, "esborrar")}
            selectedTipus={selectedTipus}
            filterText={filterText}
            setFilterText={setFilterText}
            categoriaFilter={categoriaFilter}
            setCategoriaFilter={setCategoriaFilter}
            mostrarActius={mostrarActius}
            setMostrarActius={setMostrarActius}
            reloadToken={reloadToken}
            setTipusList={setTipusList}
          />
        </>
      ) : (
        <Detallstipusdematerials
          mode={activeTab}
          tipusDeMaterial={activeTab === "nou" ? null : selectedTipus}
          tipusLlista={tipusList}
          onNavigate={setSelectedTipus}
          onCancel={() => tornarLlista(false)}
          onDeleted={() => tornarLlista(true)}
          onCanviarMode={(modeNou) => setActiveTab(modeNou)}
          onSave={(updated) => {
            if (activeTab === "nou") {
              tornarLlista(true);
              return;
            }
            setSelectedTipus(updated);
            setTipusList((prev) =>
              (prev || []).map((t) => (idTipus(t) === idTipus(updated) ? { ...t, ...updated } : t))
            );
            setActiveTab("consultar");
          }}
        />
      )}
    </div>
  );
}

export default TipusDeMaterials;
